import {useEffect, useMemo} from "react";
import {useForm, Controller, useFieldArray} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Col, Row, Space } from "antd";
import {
	Icon,
	Button,
	Loading
} from "~/components";
import {
	InputField
} from "~/components/Forms";

function AttributeFormAddEdit({item, onAdd, onUpdate})
{
	const isEdit = Boolean(item?.id);

	const initialValues = useMemo(
		() => ({
			name: item?.name ?? "",
			items: (item?.items && item.items.length > 0) ? item.items : [{name: ""}],
		}),
		[item]
	);

	const validationSchema = Yup.object().shape({
		name: Yup.string().nullable().required('Bạn phải điền tên thuộc tính'),
		items: Yup.array()
			.of(Yup.object({
				id: Yup.number().nullable(),
				name: Yup.string().trim().required('Bạn phải nhập tên giá trị'),
			}))
			.min(1, 'Cần ít nhất 1 giá trị'),
	})

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	const {fields, append, remove} = useFieldArray({
		control,
		name: 'items'
	});

	useEffect(() =>
	{
		reset(initialValues);
	}, [initialValues, reset]);

	const onSubmit = async (data) =>
	{
		data.items = (data.items || []).filter((child) => (child?.name || '').trim() !== '');

		if(isEdit)
		{
			await onUpdate(data, item);
		}
		else
		{
			await onAdd(data);
		}
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<Row gutter={10}>
				<Col span={24}>
					<Controller control={control} name="name" render={({ field }) => (
						<InputField
							label={"Tên thuộc tính"}
							errors={errors}
							{...field}
						/>
					)} />
				</Col>
			</Row>

			<p className="heading mt-2">Giá trị thuộc tính</p>
			<Space direction="vertical" style={{width: '100%'}} size={8}>
				{fields.map((field, index) => (
					<Row gutter={10} key={field.id} align="middle">
						<Col span={22}>
							<Controller control={control} name={`items.${index}.name`} render={({ field }) => (
								<InputField errors={errors}{...field}/>
							)} />
							<Controller control={control} name={`items.${index}.id`} render={({ field }) => (
								<input type="hidden" {...field} />
							)} />
						</Col>
						<Col span={2}>
							<Button background red type="button" className={'mb-1'} onClick={() => remove(index)} disabled={fields.length <= 1}>{Icon.delete}</Button>
						</Col>
					</Row>
				))}
				<Button outline type="button" onClick={() => append({name: ""})}>Thêm giá trị</Button>
			</Space>

			<hr />
			<div className="form-group d-flex justify-content-end">
				<Button primary type="submit">{isEdit ? 'Cập nhật' : 'Thêm thuộc tính'}</Button>
			</div>
		</form>
	)
}

export default AttributeFormAddEdit;
